// /forbidden — generic "not available for your role" landing page.
// Lives outside any role-gated tree so an admin who is demoted
// mid-session doesn't loop infinitely.
//
// Today no route redirects here automatically (admin gates render
// inline forbidden cards instead). Kept as a target for future direct
// "you don't have access" links.

import { Link, createFileRoute } from "@tanstack/react-router";
import { Card } from "@/design-system";
import { Lock } from "lucide-react";

export const Route = createFileRoute("/forbidden")({
  component: ForbiddenPage,
});

function ForbiddenPage() {
  return (
    <div className="flex flex-col items-center justify-center flex-1 p-8">
      <Card className="max-w-md w-full p-8 flex flex-col items-center gap-4 text-center">
        <Lock size={28} className="text-fg-3" strokeWidth={1.5} />
        <h1 className="text-[20px] font-medium text-fg-1">
          Not available for your role
        </h1>
        <p className="text-[14px] text-fg-2 leading-relaxed">
          This page is only available to org admins. If you need access to
          billing or org settings, ask an admin to invite you or upgrade
          your role.
        </p>
        <Link
          to="/targets"
          className="text-small text-accent hover:underline"
        >
          ← Back to servers
        </Link>
      </Card>
    </div>
  );
}
